<template>
  <div class="clearfix">
    <div class="document-row">
      <div class="clearfix">
        <span v-if="dealerName">
          <span
            class="dealer-name"
            v-text="dealerName"
          />

          <br>
        </span>

        <span v-text="doc.displayName()" />
        <i
          v-if="!doc.is_stored"
          class="document-loader"
        >
          <font-awesome-icon
            icon="circle-notch"
            spin
          />
          Uploading...
        </i>
        <div class="pull-right">
          <form
            :action="downloadLink"
            method="post"
          >
            <input
              :value="token"
              name="token"
              type="hidden"
            >
            <button
              :disabled="disabled"
              type="submit"
              class="btn-link"
            >
              <font-awesome-icon icon="download" />
              <span
                v-text="doc.template_document
                  && doc.template_document.show_files
                  && doc.files.length > 1
                  ? 'Download as Zip'
                  : 'Download'"
              />
            </button>
          </form>
        </div>
        <div
          v-if="doc.signature_is_required && doc.template_document.signature_areas.length"
          class="pull-right"
        >
          <button
            class="btn-link"
            :disabled="disabled"
            @click="getDocumentToSign"
          >
            <font-awesome-icon icon="file-signature" />
            Add signature
          </button>
        </div>
        <ul
          v-if="doc.template_document
            && doc.template_document.show_files
            && doc.files.length > 1"
          class="list-group"
        >
          <li
            v-for="file in doc.files"
            :key="file.id"
            class="list-group-item"
          >
            <font-awesome-icon icon="caret-right" />
            <span v-text="file.display_name || file.original_filename" />
            <form
              :action="getFileDownloadLink(file.id)"
              method="post"
            >
              <input
                :value="token"
                name="token"
                type="hidden"
              >
              <button
                type="submit"
                class="btn-link"
              >
                <font-awesome-icon icon="download" />
              </button>
            </form>
          </li>
        </ul>
      </div>
      <pdf-viewer
        v-if="currentFile"
        :base64="currentFile"
        :signature-areas="Object.values(doc.template_document.signature_areas)"
        :is-loading="loadingDocument"
        :additional-data="signatureData"
        can-sign
        @signed="saveSignature"
      />
    </div>
  </div>
</template>

<script>
import PdfViewer from '@itccompliance/compliance-pdf-viewer';

/* eslint-disable camelcase */
export default {
  components: { PdfViewer },
  props: {
    dealId: {
      type: Number,
      default: null,
    },
    dealerName: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    doc: {
      type: Object,
      default: null,
    },
    signatureData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      token: document.head.querySelector('[name="jwt-token"]').content,
      currentFile: null,
      loadingDocument: false,
    };
  },
  computed: {
    downloadLink() {
      const { base_url } = window.backendConfig.jct;
      return `${base_url}/customer-deals/${this.dealId}/documents/${this.doc.id}/download`;
    },
  },
  methods: {
    getFileDownloadLink(fileId) {
      const { base_url } = window.backendConfig.jct;
      return `${base_url}/customer-deals/${this.dealId}/documents/${this.doc.id}/${fileId}`;
    },
    async getDocumentToSign() {
      this.currentFile = null;
      this.loadingDocument = true;
      const document = await this.ApiService.fetchDocument(this.dealId, this.doc.id);
      this.currentFile = document[0].base64;
      this.loadingDocument = false;
      this.$emit('view');
    },
    async saveSignature(data) {
      this.loadingDocument = true;
      await this.ApiService.saveSignature(this.dealId, this.doc.id, data);
      this.currentFile = null;
      this.loadingDocument = false;
      this.$emit('document-signed');
    },
  },
};
</script>

<style lang="scss" scoped>
form .btn-link {
  height: auto !important;
  border: 0 none;
}

.document-row {
  .dealer-name {
      font-size: 0.75em;
  }
  .document-loader {
    margin-left: 1rem;
  }
  .list-group {
    margin: 0;
    .list-group-item {
      padding-left: 0;
      svg {
        margin: 0 10px;
      }
      form {
        display: inline;
      }
    }
  }
}
</style>
